<div class="modal-action-container">
  <button ejs-button cssClass="e-flat e-primary" (click)="onCancel()">
    CANCEL
  </button>
  <button ejs-button cssClass="e-flat e-primary" (click)="onConfirm()">
    REMOVE
  </button>
</div>
